// @flow
import config from '../../config';
import { makeAPICall, APIError } from '../generalCreators';
import { setToken, decodeToken } from '../authentication/authCreators';
import type { User, ThunkAction } from '../../types';

export function registerUser(user: User): ThunkAction {
  return function(dispatch) {
    const endpoint = '/account/register';
    const options = {
      method: 'POST',
      params: { productId: config.productId },
      data: user
    };
    return makeAPICall(endpoint, options).then(
      response => {
        const { user, token } = response.data;
        dispatch(setToken(token, user));
        dispatch(decodeToken(token));
      },
      error => dispatch(APIError(error, 'Error registering new user'))
    );
  };
}

export function registerInvitedUser(user: User, token: ?string): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = '/account/register/invited';
    const options = {
      method: 'PUT',
      headers: { token },
      params: { productId: config.productId },
      data: user
    };
    return makeAPICall(endpoint, options).then(
      response => {
        const { user, token } = response.data;
        dispatch(setToken(token, user));
        dispatch(decodeToken(token));
      },
      error => dispatch(APIError(error, 'Error registering invited user'))
    );
  };
}

// SMS
export function sendVerificationSMS(mobile: string): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = '/account/verify/phone';
    const options = {
      method: 'PUT',
      headers: { token: getState().authentication.token },
      params: { productId: config.productId },
      data: { mobile }
    };
    return makeAPICall(endpoint, options).then(
      response => response.data.message,
      error => dispatch(APIError(error, 'Error sending sms verification'))
    );
  };
}

export function checkVerificationCode(code: string): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = `/account/verify/phone/${code}`;
    const options = {
      method: 'GET',
      headers: { token: getState().authentication.token },
      params: { productId: config.productId }
    };
    return makeAPICall(endpoint, options).then(
      response => response.data.user,
      error => dispatch(APIError(error, 'Error verifying sms code'))
    );
  };
}

// EMAIL
export function sendVerificationEmail(email: string): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = '/account/verify/email';
    const options = {
      method: 'PUT',
      headers: { token: getState().authentication.token },
      data: {
        email
      }
    };
    return makeAPICall(endpoint, options).then(
      response => response.data.message,
      error => dispatch(APIError(error, 'Error sending email verification'))
    );
  };
}

export function checkVerificationEmail(token: string): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = '/account/verify/email';
    const options = {
      method: 'GET',
      headers: { token }
    };
    return makeAPICall(endpoint, options).then(
      response => response.data.user,
      error => dispatch(APIError(error, 'Error checking email verification'))
    );
  };
}



// WEBPACK FOOTER //
// ./src/actions/users/registrationCreators.js